import * as types from "./solicitarDocumento.actionTypes";

export default {
  setTokenRecaptcha: data => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data
  }),
  toggleModalPesquisaDocumento: () => ({
    type: types.TOGGLE_MODAL_PESQUISA_DOCUMENTO
  }),
  verificaDocumentoLiberadoSolicitacao: () => ({
    type: types.VERIFICA_DOCUMENTO_LIBERADO_SOLICITACAO
  }),
  pesquisarSolicitacaoDocumentoModal: data => ({
    type: types.PESQUISAR_SOLICITACAO_DOCUMENTO_MODAL,
    payload: data
  }),
  setPesquisaDocumento: data => ({
    type: types.SET_GRID_PESQUISA_DOCUMENTO,
    payload: data
  }),
  abrirSolicitacaoDocumento: data => ({
    type: types.ABRIR_SOLICITACAO_DOCUMENTO,
    payload: data
  }),
  setSolicitacaoDocumentoPost: data => ({
    type: types.SET_SOLICITACAO_DOCUMENTO_POST,
    payload: data
  }),
  setGridResultadoDocumento: data => ({
    type: types.SET_GRID_RESULTADO_DOCUMENTO,
    payload: data
  }),
  resetSolicitacaoDocumentoPost: () => ({
    type: types.RESET_SOLICITACAO_DOCUMENTO_POST,
  }),
  toggleModalResultadoDocumento: () => ({
    type: types.TOGGLE_MODAL_RESULTADO_DOCUMENTO
  }),
  setGridSolicitarDocumento: data => ({
    type: types.SET_GRID_SOLICITAR_DOCUMENTO,
    payload: data
  }),
  validaGridSolicitarDocumento: data => ({
    type: types.VALIDA_GRID_SOLICITAR_DOCUMENTO,
    payload: data
  }),
  removeGridSolicitarDocumento: data => ({
    type: types.REMOVE_GRID_SOLICITAR_DOCUMENTO,
    payload: data
  }),
  pesquisarSolicitacaoDocumento: data => ({
    type: types.PESQUISAR_SOLICITACAO_DOCUMENTO,
    payload: data
  }),
  postSolicitacaoDocumento: (data) => ({
    type: types.POST_SOLICITACAO_DOCUMENTO,
    payload: data
  }),
  setHeaderDocumento: data => ({
    type: types.SET_HEADER_DOCUMENTO,
    payload: data
  }),
  setSuggestionDocumento: data => ({
    type: types.SET_SUGGESTION_DOCUMENTO,
    payload: data
  }),
  setRecaptchaResetRefModal: data => ({
    type: types.SET_RECAPTCHA_RESET_REF_MODAL,
    payload: data
  }),
  setTokenRecaptchaModal: data => ({
    type: types.SET_TOKEN_RECAPTCHA_MODAL,
    payload: data
  }),
  mergeSolicitacaoDocumentoPost: data => ({
    type: types.MERGE_SOLICITACAO_DOCUMENTO_POST,
    payload: data
  }),
};
